module.exports = __webpack_public_path__ + "static/media/s_v9_t9.9f30990e.mp3";